let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Viih")).then(() => parcelRequire('23gQn'));